/* eslint-disable @typescript-eslint/no-explicit-any */

import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table'
import { v4 as uuidv4 } from 'uuid'
import { Skeleton } from '@radix-ui/themes'
import { IconCircleCheck } from '@tabler/icons-react'

interface IDataGridProps {
  columns: any
  data: any
  loading: boolean
  classNames?: string
  sortColumn?: string | undefined
  sortOrder?: string | undefined
  sortFunction?: (column: string) => void
}

function IntelDataGrid(props: IDataGridProps) {
  const { columns, data, loading, sortFunction, sortColumn, sortOrder, classNames = 'max-h-[460px]' } = props

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <>
      {data && data.length > 0 && !loading && (
        <div className={`${classNames} overflow-y-auto border-collapse`}>
          <table className="w-full">
            <thead
              className="bg-cardFill h-[56px] border-b border-mainBorder"
              style={{
                position: 'sticky',
                top: 0,
                zIndex: 1,
              }}
            >
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={uuidv4()} className="text-left h-[56px]">
                  {headerGroup.headers.map((header) => (
                    <th
                      key={uuidv4()}
                      className={`font-normal text-sm pl-4 ${header.column.getCanSort() && sortFunction ? 'cursor-pointer' : ''}`}
                      onClick={() => {
                        header.column.getCanSort() && sortFunction ? sortFunction(header.column.id) : null
                      }}
                    >
                      {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                      <span className="p-1">
                        {header.column.id === sortColumn ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr key={uuidv4()} className="h-14 border-mainBorder border-b last:border-b-0">
                  {row.getVisibleCells().map((cell) => (
                    <td
                      key={uuidv4()}
                      className="text-sm pl-4"
                      style={{
                        maxWidth: '300px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        paddingRight: '10px',
                      }}
                    >
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {data && data.length === 0 && !loading && (
        <div className="flex justify-center items-center my-[38px]">
          <div className="block">
            <IconCircleCheck size={24} className="w-full mr-1 text-neutral-11 dark:text-neutral-9 mx-auto mb-2" />
            <p className="text-neutral-11 dark:text-neutral-9 text-sm">This device has had no alerts</p>
          </div>
        </div>
      )}

      {(!data || loading) && (
        <div className="flex justify-center items-center mt-20">
          <Skeleton className="h-[300px] w-full flex-grow" />
        </div>
      )}
    </>
  )
}

export default IntelDataGrid
